import React from 'react'

function ActTabTam() {
  return (
    <div></div>
  )
}

export default ActTabTam